import React, {useCallback} from "react";
import {UserLocalStorageApi} from "../apis/local-storage/UserLocalStorageApi";

type UseUserStorageProps<T> = {
    key: string;
    defaultValue?: T;
}

const UseUserStorage = <T>({key, defaultValue}: UseUserStorageProps<T>) => {

    const [item, setItem] = React.useState<T>(defaultValue ?? undefined);
    const [loading, setLoading] = React.useState(true);


    const saveItemToStorage = useCallback(saveLinks => {
        UserLocalStorageApi.setItem({key, value: saveLinks}).catch(() => {
            // Ignore errors
        });
    }, [key]);

    React.useEffect(() => {
        const loadLinksFromRemoteStorage = () => {
            UserLocalStorageApi.getItem({key}).then(storageItem => {
                setItem(storageItem.item ?? defaultValue ?? undefined);
                setLoading(false);
            }).catch(() => {
                setLoading(false);
            });
        }

        loadLinksFromRemoteStorage();

        setLoading(false);
    }, [defaultValue, key, saveItemToStorage]);


    return {
        item,
        setItem: (item: T) => {
            setItem(item);
            saveItemToStorage(item);
        },
        loading
    }
}

export default UseUserStorage;
